import React, { useEffect, useState } from "react";
import { Row, Col, Form, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Card from "../Card";
import axios from "axios";
import imgsuccess from "../../assets/images/pages/img-success.png";
import Select from "react-select";
import "../../assets/css/stepper.css";
import { getUserList } from "../../services/Users-services";
import {
  addRegion,
  getRegionDetails,
  updateRegion,
} from "../../services/Organization-services";

import {
  callToast,
  showErrorMessages,
} from "../../services/utilityFunctions.js";
import {
  getCountryList,
  getCityList,
  getStateList,
} from "../../services/system.js";
import { useGlobalState } from "../../services/hostelConst";
import {
  selectTutorToAddInSubject,
  addTutorToSubject,
} from "../../services/Academic-Services";
import { getLocalStorageData } from "../../services/axiosComponent";
import { getProfileDetails } from "../../services/authentication";
import { useSelector, useDispatch } from "react-redux";
import {
  openModal,
  closeModal,
} from "../../services/redux/reducers/modalSlice";

const AddTutorToSubject = ({ navigate, refresh }) => {
  const modal = useSelector((state) => state.modal);
  const dispatch = useDispatch();

  const [step, setStep] = useState(1);

  const prepareFormData = (data = null) => {
    return {
      // Site Info

      tutorId: {
        value: data == null ? "" : data._ID,
        label: data == null ? "" : data.NAME,
      },
    };
  };
  const [formData, setFormData] = useState(prepareFormData());

  const [loadingTutorOptions, setLoadingTutorOptions] = useState(false);

  const [tutorOptions, setTutorOptions] = useState([]);

  const [tutorName, setTutorName] = useState(undefined);

  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const getSubjectOptions = async () => {
    setLoadingTutorOptions(true);
    const res = await selectTutorToAddInSubject({
      query: tutorName,
      entityId: modal.data._ID,
      organizationId:
        getLocalStorageData("profileDetails")["_ORGANIZATION_"]._ID,
      regionId: modal.data._REGION,
      siteId: modal.data._SITE,
      status: "Y",
    });
    if (res.status == "success") {
      console.log("called getSubjectOptions" + res);
      var list = [];
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item["NAME"],
        });
      });
      setTutorOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingTutorOptions(false);
  };
  useEffect(() => {
    getSubjectOptions();

    return () => {};
  }, []);

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });

    setErrors({ ...errors, [field]: "" });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.tutorId || !formData.tutorId.value) {
      newErrors.tutorId = "Subject is required";
    }

    // Step 2 validation

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      var dataToSubmit = {
        tutorId: formData.tutorId.value,
        regionId: modal.data._REGION,
        siteId: modal.data._SITE,
        tutorId: modal.data._ID,
        organizationId:
          getLocalStorageData("profileDetails")["_ORGANIZATION_"]._ID,
        id: modal.isEditing ? modal.data._ID : null,
      };

      var res = await addTutorToSubject(dataToSubmit);
      if (res.status == "success") {
        callToast(
          "success",
          "Success",

          res?.message
        );
        await refresh({ columnRefresh: false, isLoading: false });
        dispatch(closeModal());
      } else {
        showErrorMessages({ data: res, navigate });
      }
      setLoading(false);
    }
  };
  const handleNextStep = () => {
    if (validateForm()) {
      setStep(step + 1);
    }
  };

  return (
    <>
      <section className="">
        <div className="d-flex  justify-content-center ">
          <div className="w-100 m-3">
            <div className="d-flex h-100">
              <div className="w-100">
                <>
                  {
                    // Step 1: Site Info
                    <>
                      <div className="row mb-3 m-4 me-2 ms-2">
                        <div className="col-md-12">
                          <label className="form-label">Tutor</label>
                          <Select
                            options={tutorOptions}
                            value={
                              formData.tutorId.label === ""
                                ? null
                                : formData.tutorId
                            }
                            onChange={(value) =>
                              handleChange(
                                "tutorId",
                                value == null ? { value: "", label: "" } : value
                              )
                            }
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                height: "100px", // Set dropdown height
                              }),
                              menuList: (provided) => ({
                                ...provided,
                                maxHeight: "100px", // Set max height for the list
                                overflowY: "auto",
                              }),
                            }}
                            placeholder="Select Tutor"
                            isSearchable
                            onInputChange={(inputValue) => {
                              if (inputValue.length > 0) {
                                setTutorName(inputValue);
                                getSubjectOptions();
                              }
                            }}
                            noOptionsMessage={() => {
                              return "No Tutor Found";
                            }}
                            components={
                              loadingTutorOptions
                                ? {
                                    DropdownIndicator,
                                  }
                                : null
                            }
                            className="basic-single"
                            classNamePrefix="select"
                            filterOption={(option, inputValue) =>
                              option.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                          />
                          {errors.tutorId && (
                            <small className="text-danger">
                              {errors.tutorId}
                            </small>
                          )}
                        </div>
                      </div>

                      <div className="d-flex justify-content-end m-3 mb-0">
                        <Button
                          type="submit"
                          disabled={loading}
                          onClick={handleSubmit}
                        >
                          {loading ? (
                            <div
                              class="spinner-border text-light"
                              role="status"
                            >
                       
                            </div>
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </div>
                    </>
                  }
                </>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        class="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
 
      </div>
    </div>
  );
};

export default AddTutorToSubject;
